import { FC } from "react";

import { FramerTooltip } from "@ryde/controls";
import { useDrawers } from "@ryde/shared";

import { IRideBottomSiteDisplayItem } from "../ride-tabs-bottom-sites.models";
import { RideTabsBottomSiteItemContent } from "./ride-tabs-bottom-site-item-content";
import { RideTabsBottomSitesTooltip } from "./ride-tabs-bottom-sites-tooltip";

interface IRideTabsBottomSiteItemProps {
  item: IRideBottomSiteDisplayItem;
}

export const RideTabsBottomSiteItem: FC<IRideTabsBottomSiteItemProps> = ({
  item,
}) => {
  const { openEditFormDrawer } = useDrawers();

  const handleSiteClick = (): void => {
    if (!item.isClickable || item.siteId <= 0) {
      return;
    }

    openEditFormDrawer({
      entity: "site",
      id: item.siteId,
    });
  };

  return (
    <FramerTooltip
      content={<RideTabsBottomSitesTooltip item={item} />}
      rtlStrippedBottomLeftPlacement
    >
      <RideTabsBottomSiteItemContent
        item={item}
        onSiteClick={handleSiteClick}
      />
    </FramerTooltip>
  );
};
